// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    showProductsCount = "showProductsCount",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showProductsCount]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;
    return {
        currentPage: getCurrentPage(state),
        query: correctedQuery || productFilters.query,
    };
};

type Props = OwnProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

// <XNG-Changes>
interface CategoryNameStyles {
    titleWrapper?: InjectableCss;
    categoryName?: TypographyProps;
}
export const categoryNameStyles: CategoryNameStyles = {};
const styles = categoryNameStyles;

const CategoryName = ({ category, fields, query, currentPage }: Props) => {
    // XNG-CHANGES
    const AllProductsPageTitle = currentPage.fields.title;
    const isAllProductsPage = currentPage.type === "AllProductsPage";

    if (category || isAllProductsPage) {
        // XNG-Changes: change structure & add number of products
        return (
            <StyledWrapper {...styles.titleWrapper} className="category-title-wrapper">
                <Typography {...styles.categoryName}>
                    {isAllProductsPage
                        ? AllProductsPageTitle
                        : category && (category.shortDescription ?? category.name)}
                </Typography>
                {fields.showProductsCount && createWidgetElement("ProductList/ProductListProductCount", { fields: {} })}
            </StyledWrapper>
        );
    }
    return <>{createWidgetElement("ProductList/ProductListProductCount", { fields: {} })}</>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.showProductsCount,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
